export const convertWeiTo = ({ price = 0, priceConversion = 1}) => {
  const maticValue = (price ?? 0) / Math.pow(10, 18);
  return (maticValue * priceConversion).toFixed(4);
}